import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { either, equals } from '@/utils/common';
import { compareUrls, skipFileExtension } from '@/utils/navigation';

export const normalizePath = (path: string) => path.replace(/^\/+/, '/').replace(/\/{2,}/g, '/');

const isCurrentPath = (linkHref: string, href: string) => {
  if (equals(href, '/index')) {
    const isRelative = either(equals('../'), equals('./'));
    if (isRelative(linkHref)) return true;
  }
  return compareUrls(href, linkHref);
};

const getLinkMessage = (href: string, htmlString?: string) => {
  if (!htmlString) return '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const link = Array.from(doc.querySelectorAll('a')).find(link => {
    const linkHref = link.getAttribute('href');

    return linkHref && isCurrentPath(linkHref, href) && equals(link.className, 'reference internal');
  });

  if (link) {
    return link.innerText;
  }

  return '';
};

export const useCurrentLinkText = (slug = '', sidebarSrc?: string) => {
  const pathname = usePathname();
  const [currentLinkName, setCurrentLinkName] = useState('');
  const cleanPathname = skipFileExtension('html', pathname.replace(slug, ''));

  useEffect(() => {
    setCurrentLinkName(getLinkMessage(normalizePath(cleanPathname), sidebarSrc));
  }, [sidebarSrc, cleanPathname]);

  return currentLinkName;
};
